import { DataGridRow } from 'components/DataGrid';
import TextInput from 'components/Input/TextInput';
import { fieldType } from 'models/response';
import React from 'react';

export interface CellTextInput {
  row: DataGridRow;
  code: number;
  predictionsValuesBody: DataGridRow[];
  dataType?: fieldType;
  hTableValues?: {
    code: string;
    description: string;
    sign?: 1 | -1 | undefined;
  }[];
}

const CellPredictionTextInput = ({ row, code, predictionsValuesBody, dataType, hTableValues }: CellTextInput) => {
  let value = '';
  const fieldValue = predictionsValuesBody.find(({ id }) => id === row.id);
  if (fieldValue) {
    value = fieldValue[code]?.content || '';

    if (dataType && dataType === 3) {
      const fromTableValues = hTableValues?.find((el) => el.code === value);
      if (fromTableValues) value = `${fromTableValues.code} - ${fromTableValues.description}`;
    }
  }

  return (
    <TextInput
      id={`cell-prediction-text-input-${row.id}`}
      title={value}
      value={value}
      type={'text'}
      noBorder={true}
      fullWidth={true}
      className="cell-text-input"
      disabled
    />
  );
};
export default CellPredictionTextInput;
